// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branchManager_submitBtn__mucej {
  color: #000000 !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  letter-spacing: normal !important;
  text-align: center !important;
  background:  rgba(30, 229, 118, 1)  !important;
  padding: 16px !important;
  border-radius: 100px !important;
  border: none !important;
  cursor: pointer !important;
  margin-top: 0;
}

:root {
  --accent-green:  rgba(30, 229, 118, 1) ; /* same as submitBtn */
  --text-dark: #000000;
  --table-bg: #ffffff;
  --table-header-bg: #046A38;
  --table-header-border: rgba(30, 229, 118, 0.30);
  --table-row-hover: rgba(30, 229, 118, 0.08);
  --table-border: #e9ecef; /* close to Bootstrap's border color */
  --table-row-odd: #CEE5CB;
  --table-row-even: #ECF3EB;
}

.branchManager_table-theme__UFrTw {
  font-family: "DM Sans", sans-serif;
  color: var(--text-dark);
}

.branchManager_table-theme__UFrTw .branchManager_table-card__BuUnz {
  background: var(--table-bg);
  border: 1px solid var(--table-border);
  /* border-radius: 16px; */
  box-shadow: 0 8px 24px rgba(0,0,0,0.06);
}

.branchManager_table-theme__UFrTw .branchManager_table__voTsi {
  margin: 0;
  border-collapse: separate;       
  border-spacing: 0;
}

.branchManager_table-theme__UFrTw .branchManager_table__voTsi thead th {
  background: var(--table-header-bg);
  border-bottom: 2px solid var(--table-header-border);
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.2px;
  text-transform: none;
}

.branchManager_table-theme__UFrTw .branchManager_table__voTsi tbody td,
.branchManager_table-theme__UFrTw .branchManager_table__voTsi thead th {
  padding: 8px 16px; /* visually aligned with your button’s comfort spacing */
}
.branchManager_table-theme__UFrTw .branchManager_table__voTsi tbody tr:nth-child(odd) {
  background: var(--table-row-odd);
}

.branchManager_table-theme__UFrTw .branchManager_table__voTsi tbody tr:nth-child(even) {
  background: var(--table-row-even);
}
.branchManager_table-theme__UFrTw .branchManager_table__voTsi tbody tr:hover {
  background: var(--table-row-hover);
}

.branchManager_table-theme__UFrTw .branchManager_table__voTsi tbody tr + tr td {
  border-top: 1px solid var(--table-border);
}

.branchManager_table-theme__UFrTw .branchManager_table__voTsi tbody td.branchManager_id-col__AnbFj {
  color: var(--text-dark);
  font-weight: 500;
}

.branchManager_table-theme__UFrTw .branchManager_badge-accent__Fx\\+Us {
  display: inline-block;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #0f7a4d; /* readable on light background */
  background: rgba(30, 229, 118, 0.18);
  border: 1px solid rgba(30, 229, 118, 0.35);
}

.branchManager_table-theme__UFrTw .branchManager_btn-outline-accent__IRVYs {
  color: var(--text-dark);
  border-radius: 100px;
  border: 1px solid rgba(0,0,0,0.12);
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  background: #fff;
}
.branchManager_table-theme__UFrTw .branchManager_btn-outline-accent__IRVYs:hover {
  border-color: rgba(30, 229, 118, 0.8);
  color: #0f7a4d;
  background: rgba(30, 229, 118, 0.08);
}

.branchManager_table-theme__UFrTw .branchManager_btn-accent__nB\\+c6 {
  color: var(--text-dark) !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  text-align: center !important;
  background: var(--accent-green) !important;
  padding: 10px 18px;                
  border-radius: 100px !important;
  border: none !important;
  cursor: pointer !important;
}

@media (max-width: 576px) {
  .branchManager_table-theme__UFrTw .branchManager_table__voTsi thead th,
  .branchManager_table-theme__UFrTw .branchManager_table__voTsi tbody td {
    padding: 12px 12px;
    font-size: 13px;
  }
  .branchManager_table-theme__UFrTw .branchManager_table__voTsi thead th:last-child,
  .branchManager_table-theme__UFrTw .branchManager_table__voTsi tbody td:last-child {
    white-space: nowrap;
  }
}
.branchManager_bg-green__6vVWy{
      background-color:  rgba(30, 229, 118, 1)  !important;
    border: none !important;
    color: #000000 !important;
}
.branchManager_text-align-end__JXhuE{
    text-align: end;
}

/**Pagination **/
.branchManager_pagination-wrapper__k6XED {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding: 16px 0;
  flex-wrap: wrap;
  gap: 16px;
}

.branchManager_pagination__EXiht {
  display: flex;
  gap: 8px;
  align-items: center;
}

.branchManager_page-btn__\\+Kk4D {
  border: 1px solid #e5e7eb;
  padding: 0;
  border-radius: 8px;
  cursor: pointer;
  background-color: #fff;
  color: #374151;
  transition: all 0.2s ease;
  min-height: 40px;
  min-width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
}

.branchManager_page-btn__\\+Kk4D:hover:not(:disabled):not(.branchManager_active__pF5rv) {
  background-color: rgba(30, 229, 118, 0.08);
  border-color: rgba(30, 229, 118, 0.3);
  color: #046A38;
}

.branchManager_page-btn__\\+Kk4D.branchManager_active__pF5rv {
  background-color: #046A38;
  color: #ffffff;
  border-color: #046A38;
  font-weight: 600;
}

.branchManager_page-btn__\\+Kk4D:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.branchManager_nav-btn__kekif {
  border-radius: 8px;
  padding: 0;
}

.branchManager_nav-btn__kekif svg {
  display: block;
}

.branchManager_ellipsis__i11qz {
  color: #9ca3af;
  padding: 0 4px;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}

.branchManager_pagination-info__rIx32 {
  color: #6b7280;
  font-size: 14px;
  font-weight: 400;
  font-family: "DM Sans", sans-serif;
}

@media (max-width: 640px) {
  .branchManager_pagination-wrapper__k6XED {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .branchManager_pagination-info__rIx32 {
    order: -1;
    width: 100%;
  }
}
/**Pagination **/
`, "",{"version":3,"sources":["webpack://./src/styles/branchManager/branchManager.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,8CAA8C;EAC9C,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,uCAAuC,EAAE,sBAAsB;EAC/D,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,+CAA+C;EAC/C,2CAA2C;EAC3C,uBAAuB,EAAE,sCAAsC;EAC/D,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,mDAAmD;EACnD,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB,EAAE,wDAAwD;AAC7E;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc,EAAE,iCAAiC;EACjD,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,kBAAkB;IAClB,eAAe;EACjB;EACA;;IAEE,mBAAmB;EACrB;AACF;AACA;MACM,oDAAoD;IACtD,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF;AACA,gBAAgB","sourcesContent":[".submitBtn {\n  color: #000000 !important;\n  font-family: \"DM Sans\", sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  letter-spacing: normal !important;\n  text-align: center !important;\n  background:  rgba(30, 229, 118, 1)  !important;\n  padding: 16px !important;\n  border-radius: 100px !important;\n  border: none !important;\n  cursor: pointer !important;\n  margin-top: 0;\n}\n\n:root {\n  --accent-green:  rgba(30, 229, 118, 1) ; /* same as submitBtn */\n  --text-dark: #000000;\n  --table-bg: #ffffff;\n  --table-header-bg: #046A38;\n  --table-header-border: rgba(30, 229, 118, 0.30);\n  --table-row-hover: rgba(30, 229, 118, 0.08);\n  --table-border: #e9ecef; /* close to Bootstrap's border color */\n  --table-row-odd: #CEE5CB;\n  --table-row-even: #ECF3EB;\n}\n\n.table-theme {\n  font-family: \"DM Sans\", sans-serif;\n  color: var(--text-dark);\n}\n\n.table-theme .table-card {\n  background: var(--table-bg);\n  border: 1px solid var(--table-border);\n  /* border-radius: 16px; */\n  box-shadow: 0 8px 24px rgba(0,0,0,0.06);\n}\n\n.table-theme .table {\n  margin: 0;\n  border-collapse: separate;       \n  border-spacing: 0;\n}\n\n.table-theme .table thead th {\n  background: var(--table-header-bg);\n  border-bottom: 2px solid var(--table-header-border);\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0.2px;\n  text-transform: none;\n}\n\n.table-theme .table tbody td,\n.table-theme .table thead th {\n  padding: 8px 16px; /* visually aligned with your button’s comfort spacing */\n}\n.table-theme .table tbody tr:nth-child(odd) {\n  background: var(--table-row-odd);\n}\n\n.table-theme .table tbody tr:nth-child(even) {\n  background: var(--table-row-even);\n}\n.table-theme .table tbody tr:hover {\n  background: var(--table-row-hover);\n}\n\n.table-theme .table tbody tr + tr td {\n  border-top: 1px solid var(--table-border);\n}\n\n.table-theme .table tbody td.id-col {\n  color: var(--text-dark);\n  font-weight: 500;\n}\n\n.table-theme .badge-accent {\n  display: inline-block;\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #0f7a4d; /* readable on light background */\n  background: rgba(30, 229, 118, 0.18);\n  border: 1px solid rgba(30, 229, 118, 0.35);\n}\n\n.table-theme .btn-outline-accent {\n  color: var(--text-dark);\n  border-radius: 100px;\n  border: 1px solid rgba(0,0,0,0.12);\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 500;\n  background: #fff;\n}\n.table-theme .btn-outline-accent:hover {\n  border-color: rgba(30, 229, 118, 0.8);\n  color: #0f7a4d;\n  background: rgba(30, 229, 118, 0.08);\n}\n\n.table-theme .btn-accent {\n  color: var(--text-dark) !important;\n  font-family: \"DM Sans\", sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  text-align: center !important;\n  background: var(--accent-green) !important;\n  padding: 10px 18px;                \n  border-radius: 100px !important;\n  border: none !important;\n  cursor: pointer !important;\n}\n\n@media (max-width: 576px) {\n  .table-theme .table thead th,\n  .table-theme .table tbody td {\n    padding: 12px 12px;\n    font-size: 13px;\n  }\n  .table-theme .table thead th:last-child,\n  .table-theme .table tbody td:last-child {\n    white-space: nowrap;\n  }\n}\n.bg-green{\n      background-color:  rgba(30, 229, 118, 1)  !important;\n    border: none !important;\n    color: #000000 !important;\n}\n.text-align-end{\n    text-align: end;\n}\n\n/**Pagination **/\n.pagination-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 24px;\n  padding: 16px 0;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.pagination {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.page-btn {\n  border: 1px solid #e5e7eb;\n  padding: 0;\n  border-radius: 8px;\n  cursor: pointer;\n  background-color: #fff;\n  color: #374151;\n  transition: all 0.2s ease;\n  min-height: 40px;\n  min-width: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"DM Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n}\n\n.page-btn:hover:not(:disabled):not(.active) {\n  background-color: rgba(30, 229, 118, 0.08);\n  border-color: rgba(30, 229, 118, 0.3);\n  color: #046A38;\n}\n\n.page-btn.active {\n  background-color: #046A38;\n  color: #ffffff;\n  border-color: #046A38;\n  font-weight: 600;\n}\n\n.page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.nav-btn {\n  border-radius: 8px;\n  padding: 0;\n}\n\n.nav-btn svg {\n  display: block;\n}\n\n.ellipsis {\n  color: #9ca3af;\n  padding: 0 4px;\n  font-size: 14px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n}\n\n.pagination-info {\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: \"DM Sans\", sans-serif;\n}\n\n@media (max-width: 640px) {\n  .pagination-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .pagination-info {\n    order: -1;\n    width: 100%;\n  }\n}\n/**Pagination **/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submitBtn": `branchManager_submitBtn__mucej`,
	"table-theme": `branchManager_table-theme__UFrTw`,
	"table-card": `branchManager_table-card__BuUnz`,
	"table": `branchManager_table__voTsi`,
	"id-col": `branchManager_id-col__AnbFj`,
	"badge-accent": `branchManager_badge-accent__Fx+Us`,
	"btn-outline-accent": `branchManager_btn-outline-accent__IRVYs`,
	"btn-accent": `branchManager_btn-accent__nB+c6`,
	"bg-green": `branchManager_bg-green__6vVWy`,
	"text-align-end": `branchManager_text-align-end__JXhuE`,
	"pagination-wrapper": `branchManager_pagination-wrapper__k6XED`,
	"pagination": `branchManager_pagination__EXiht`,
	"page-btn": `branchManager_page-btn__+Kk4D`,
	"active": `branchManager_active__pF5rv`,
	"nav-btn": `branchManager_nav-btn__kekif`,
	"ellipsis": `branchManager_ellipsis__i11qz`,
	"pagination-info": `branchManager_pagination-info__rIx32`
};
export default ___CSS_LOADER_EXPORT___;
